import { createSlice } from "@reduxjs/toolkit";
import { fetchProjectSettings, updateProjectSettings } from "../Thunks/projectSettingsThunk";
import { SUPERSEDED_REQUEST } from "../helpers/asyncResource";

const initialState = {
  dataByProjectId: {},
  loadingByProjectId: {},
  savingByProjectId: {},
  errorByProjectId: {},
};

export const projectSettingsSlice = createSlice({
  name: "projectSettings",
  initialState,
  reducers: {
    clearProjectSettings: (state, action) => {
      const id = action.payload;
      if (id != null) {
        delete state.dataByProjectId[id];
        delete state.loadingByProjectId[id];
        delete state.savingByProjectId[id];
        delete state.errorByProjectId[id];
      } else {
        state.dataByProjectId = {};
        state.loadingByProjectId = {};
        state.savingByProjectId = {};
        state.errorByProjectId = {};
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchProjectSettings.pending, (state, action) => {
        const projectId = action.meta.arg;
        state.loadingByProjectId[projectId] = true;
        state.errorByProjectId[projectId] = null;
      })
      .addCase(fetchProjectSettings.fulfilled, (state, action) => {
        const projectId = action.meta.arg;
        state.loadingByProjectId[projectId] = false;
        state.errorByProjectId[projectId] = null;
        state.dataByProjectId[projectId] = action.payload;
      })
      .addCase(fetchProjectSettings.rejected, (state, action) => {
        const projectId = action.meta.arg;
        if (action.payload === SUPERSEDED_REQUEST) return;
        state.loadingByProjectId[projectId] = false;
        state.errorByProjectId[projectId] =
          action.payload ?? action.error?.message ?? "Failed to load project settings";
      })
      .addCase(updateProjectSettings.pending, (state, action) => {
        const projectId = action.meta.arg?.projectId;
        if (projectId) state.savingByProjectId[projectId] = true;
      })
      .addCase(updateProjectSettings.fulfilled, (state, action) => {
        const { projectId, data } = action.payload;
        state.savingByProjectId[projectId] = false;
        state.dataByProjectId[projectId] = data;
      })
      .addCase(updateProjectSettings.rejected, (state, action) => {
        const projectId = action.meta.arg?.projectId;
        if (projectId) state.savingByProjectId[projectId] = false;
      });
  },
});

export const { clearProjectSettings } = projectSettingsSlice.actions;

export const selectProjectSettingsData = (state, projectId) =>
  projectId != null ? (state.projectSettings?.dataByProjectId?.[projectId] ?? null) : null;

export const selectProjectSettingsLoading = (state, projectId) =>
  !!state.projectSettings?.loadingByProjectId?.[projectId];

export const selectProjectSettingsSaving = (state, projectId) =>
  !!state.projectSettings?.savingByProjectId?.[projectId];

export const selectProjectSettingsError = (state, projectId) =>
  state.projectSettings?.errorByProjectId?.[projectId] ?? null;

export default projectSettingsSlice.reducer;
